import type { FC } from 'react'
import React from 'react'

import NumberBadge from '@vfuk/core-number-badge'

import type { IconStoreOfferProps } from './IconStoreOffer.types'
import * as Styled from './styles/IconStoreOffer.style'

import { nonThemeableRules } from '../../ruleSet'

const IconStoreOffer: FC<IconStoreOfferProps> = ({
  size = nonThemeableRules.defaultSize as number as IconStoreOfferProps['size'],
  isResponsive = false,
  appearance = 'primary',
  inverse = false,
  state,
  numberBadge,
}: IconStoreOfferProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive} appearance={appearance} inverse={inverse} state={state}>
      <svg viewBox='0 0 192 192' xmlns='http://www.w3.org/2000/svg'>
        <g fill='none'>
          <circle cx='117.35' cy='126.89' r='9.73' vectorEffect='non-scaling-stroke' />
          <circle cx='74.65' cy='94.58' r='9.73' vectorEffect='non-scaling-stroke' />
          <path d='M121.89 84.85 69.74 137' vectorEffect='non-scaling-stroke' />
        </g>
        <path
          d='M132 52.13H61.17c-6 0-7.44 5.09-8 8l-17.51 88a16 16 0 0 0 16 16h88.68a16 16 0 0 0 16-16l-16.34-88c-1-3.35.24-8-8-8Z'
          fill='none'
          vectorEffect='non-scaling-stroke'
        />
        <path d='M120.28 64.13v-12a24.28 24.28 0 0 0-48.56 0v12' fill='none' vectorEffect='non-scaling-stroke' />
      </svg>
      <If condition={numberBadge}>
        <Styled.NumberBadgeContainer>
          <NumberBadge number={numberBadge!} appearance={inverse ? appearance : 'primary'} />
        </Styled.NumberBadgeContainer>
      </If>
    </Styled.IconWrapper>
  )
}

export default IconStoreOffer
